import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { loadCommonAssets } from 'store/actions/ui';
import AudioCaptions from 'components/AudioCaptions';

import border from 'assets/svg/black-line.svg';
import logo from 'assets/svg/logo.svg';

import styles from './SplashScreen.module.scss';
import { t } from '../../translations';
import { compose } from 'redux';
import withRouter from '../../hooks/withRouter';
import { withLwtStore } from '@lwtears/lwt-common-frontend/lib/LwtApp';
import { maybe } from '@lwtears/lwt-common-frontend/lib/@common/util/maybe-util';

// how long we want to stay on the splash screen
const displayTime = 3000;

const splashBackgroundColor = {
  numbers: '#F58426',
  letters: '#A0CF67',
  wdt: ''
};

const MaybeAudioCaptions = maybe(AudioCaptions);
export class SplashScreen extends Component {
  constructor(props) {
    super(props);
    this.timeoutId = null;
    this.state = {
      startTime: Date.now()
    };
  }

  componentDidMount() {
    document.title = `${t('SplashScreen')}`;
    this.props.loadCommonAssets();
  }

  componentDidUpdate(prevProps) {
    // check to see if loading has finished
    if (prevProps.loading && !this.props.loading) {
      const {
        state: { startTime },
        props: { module, router }
      } = this;

      const now = Date.now();
      const passed = now - startTime;

      if (passed >= displayTime) router.navigate(`/${module}/reward-screen`);
      else setTimeout(() => router.navigate(`/${module}/reward-screen`), displayTime - passed);
    }
  }

  componentWillUnmount() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  render() {
    const {
      settings: {
        accessibility: {
          closedCaptionsSettings: { showClosedCaptions, displayCCControl }
        }
      }
    } = this.props.lwtStoreState;

    const showAudioCaptions = showClosedCaptions && displayCCControl;

    return (
      <div
        className={styles.splashScreen}
        style={{
          background: `${splashBackgroundColor[this.props.module]}`
        }}
      >
        <div className={styles.header}>
          <div className={styles.headerContent}>
            <img className={styles.logo} src={logo} alt={styles.logo} />
          </div>
          <img className={styles.border} src={border} alt={styles.logo} />
        </div>

        <div className={styles.splashBody}>
          <div className={styles[this.props.module]} />
        </div>
        <MaybeAudioCaptions shouldRender={showAudioCaptions} className={styles.captionsContainer} />
      </div>
    );
  }
}

SplashScreen.propTypes = {
  loading: PropTypes.bool.isRequired,
  module: PropTypes.string.isRequired,
  router: PropTypes.object.isRequired,
  loadCommonAssets: PropTypes.func.isRequired,
  lwtStoreState: PropTypes.object
};

const mapStateToProps = state => ({
  loading: state.ui.loading,
  module: state.ui.module
});

const withRedux = connect(mapStateToProps, {
  loadCommonAssets
});

export default compose(withRedux, withRouter, withLwtStore)(SplashScreen);
